export const WAAS_TRIAL_LENGTH = 90;
export const TRIAL_EXPIRY_WARNING_LENGTH = 14;
